import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"
import DrawerCom from "./DrawerCom"

import BaseBtnCom from "../BaseBtnCom"
import { CancelTextBtnWrap, DrawerWinOneTileWrap, DrawerWinTwoTileWrap, PaddingLeftRightWrap } from "./DrawerStyle"
import { useCallback, useEffect, useState } from "react"
import WarnBarCom from "components/WarnBarCom"
import CInputCom from "components/Form/CInputCom"
import CSelectCom from "components/Form/CSelectCom"
import { useAppSelector } from "hooks/redux/hooks"
import { getIconUrl } from "utils"
import { useAccount } from "wagmi"
import { createWalletClient, custom, keccak256, toHex } from "viem"
import { sortParams } from "services/commonServices"
import { postSubmitTicket } from "services/ticketServices"
import toast from "react-hot-toast"

interface Props {
    open: boolean
    closeChange?: (isOpen: boolean) => void
    onComplete?: (obj?: any) => void
}

const DrawerNewTicketCom = ({open, closeChange = (isOpen) => {}, onComplete = (obj) => {}}: Props) => {
    const { chains } = useAppSelector((state) => state.app)
    const [options, setOptions] = useState<any>([])
    const { address, connector } = useAccount()

    const [txHash, setTxHash] = useState('')
    const [nickName, setNickName] = useState('')

    /**
     * 资源初始化
     */
    const fnInit = useCallback(() => {
        if(open) {
            // 初始化资源
            const tempAry = chains.map(item => {
                return {
                    label: item.fullName,
                    value: item.nickName,
                    imgUrl: getIconUrl(item.chainIndex, 'chain', 'solid'),
                    ...item
                }
            })
            setOptions(tempAry)
        } else {
            // 清理资源
            setTxHash('')
            setNickName('')
        }
    }, [chains, open])

    useEffect(() => {
        fnInit()
    }, [fnInit])

    /**
     * 关闭回调
     */
    const [closeRandom, setCloseRandom] = useState(0)
    const fnClosed = (closed: boolean) => {
        closeChange(closed)
        setCloseRandom(0)
    }
    const fnCloseWin = useCallback(() => {
        setCloseRandom(closeRandom + 1)
    }, [closeRandom])

    /**
     * 完成回调
     */
    const fnConfirm = useCallback(async () => {
        if(!(address && connector && nickName && txHash)) return
        try {
            if(!(/0[xX][0-9a-fA-F]{64}/.test(txHash))) {
                toast.error("Invalid tx hash format", {
                    duration: 3000,
                    position: 'top-right',
                })
                return
            }
            const fromAddress = address as `0x${string}`
            const provider = await connector?.getProvider()
            const walletClient = createWalletClient({
                account: fromAddress,
                transport: custom(provider)
            }) as any
            const params = {
              hash: txHash,
              chain: nickName
            }
            const freezeParams = Object.freeze(params)
            let raw = sortParams(freezeParams, fromAddress) as string
            raw = keccak256(toHex(raw))

            let signature = await walletClient?.signMessage({ 
              account: fromAddress,
              message: raw,
            })
            signature = signature.substring(2)
            const header = {
              EvmAddress: fromAddress,
              Signature: signature
            }
            const result =  await postSubmitTicket(params, header)
            if(result) {
                onComplete()
                fnCloseWin()
            }
          } catch(error) {
          }
    }, [address, connector, fnCloseWin, nickName, onComplete, txHash])

    // 业务逻辑
    const fnTxhashChange = (val: string) => {
        setTxHash(val)
    }

    const fnChainChange = (item: any) => {
        setNickName(item.nickName)
    }

    return open ? <DrawerCom isOpen={open} closeRandom={closeRandom} onClose={fnClosed}>
        <DrawerContentWrap $isError={true}>
            <PaddingLeftRightWrap>
                <DrawerWinOneTileWrap>Open a new ticket</DrawerWinOneTileWrap>
                <DrawerWinTwoTileWrap $mb="20px">Submit a new ticket with your hash and chain to report an issue. Your ticket will be sent directly to the dev team.</DrawerWinTwoTileWrap>
                <WarnBarCom bgColor="#FDFDD8" desc="Kindly anticipate a resolution within an estimated timeframe of 48 hours on average."></WarnBarCom>
                <StyledContainer $height="30px"></StyledContainer>

                <CInputCom value={txHash} label="Transaction hash" onChange={fnTxhashChange}></CInputCom>
                <StyledContainer $height="8px"></StyledContainer>
                <CSelectCom options={options} value={nickName} label="Chain" optionValue="nickName" onChange={fnChainChange} showImg={true}></CSelectCom>

                <StyledContainer $height="40px"></StyledContainer>
                <BaseBtnCom disabled={!(txHash && nickName)} type="4" title="Open ticket" onClick={fnConfirm}></BaseBtnCom>

                <CancelTextBtnWrap onClick={() => setCloseRandom(closeRandom + 1)}>Cancel</CancelTextBtnWrap>
            </PaddingLeftRightWrap>
        </DrawerContentWrap>
    </DrawerCom> : <></>
}

const DrawerContentWrap = styled(StyledContainer)<{$isError: boolean}>`
    ${
        ({$isError, theme}) => $isError ? css`
         
        ` : css`
        `
    }
`

export default DrawerNewTicketCom